<div class="main-page-content">
  <video *ngIf="loading" id="vid" autoplay="" loop="" muted="" playsinline="" class="loading-video" style="width: 100%;  position: fixed;  bottom: 0;  right: 0;  z-index: 1001;">
    <source src="/assets/video/loading.webm" type="video/webm">
  </video>
  <div class="main-page-content-block">
    <div class="row">
      <div class="col-12 ">

        <div class="float-end">
          <a class="btn btn-secondary rounded-pill me-2" [routerLink]="['/tickets/list']">View list</a>
          <a class="btn btn-secondary rounded-pill me-2" (click)="togglePinned()">
            <i class="fa fa-map-pin " role="button" title="Show pinned tickets" [@rotatedState]="rotatedPinIcon"></i>
          </a>
        </div>
        <div class="pt-2 pl-2 display-flex">
          <h3 class="content-heading-font mt-1">Support Tickets</h3>
          <div class="ml-2 p-2 mb-1 bg-white-hover round-15 float-content-center" role="button" title="Reload" (click)="reload()">
            <i class="m-0 p-0 fa fa-rotate-left font-22"></i>
          </div>
        </div>
      </div>
      <div class="col-12 pb-2" *ngIf="showPinned && pinned != null && pinned.length > 0" [@slideInOut]>
        <div class="m-0 p-0 pinned-ticket-container">
          <div class="mr-2 pinned-ticket p-3" *ngFor="let ticket of pinned">
            <div class="row justify-content-start font-bold font-14">
              <div class="col-12 col-md-6 p-0 float-content-start">
                <p class="p-0 m-0">{{ truncatePinnedUserName(ticket.Client_Name) }}</p>
              </div>
              <div class="col-12 col-md-6 p-0 float-content-end">
                <p class="p-0 m-0">{{ ticket.Client}}</p>
              </div>
              <div class="col-12 p-0 float-content-end">
                <p class="p-0 m-0">{{ ticket.DateCreated | date:'short' }}</p>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-12 p-0 float-content-start font-16">
                <p class="p-0 m-0">{{ truncatePinnedSubject(ticket.Subject) }}</p>
              </div>
              <div class="col-12 col-md-6 p-1 font-16">
                <div class="ticket-btn bg-blue-38 text-center" (click)="updatePinnedTickets(ticket)">
                  <span class="m-0 p-0">Remove Pin</span>
                </div>
              </div>
              <div class="col-12 col-md-6 p-1 font-16">
                <div class="ticket-btn bg-blue-38 text-center" (click)="openTicket(ticket.ID)">
                  <span class="m-0 p-0">View Ticket</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3 ticket-left-menu">
        <div class="row p-1 pt-3">
          <div class="col-12 main-ticket-metrics bg-dark">
            <div class="row">
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Current Open Tickets:
                </div>
                <div>
                  {{ metrics == null ? 0 : metrics.TotalOpenTicketsCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Tickets Closed > 7 Days:
                </div>
                <div>
                  {{ metrics == null ? 0 : metrics.TicketsClosedInLastSevenDaysCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Critical Tickets:
                </div>
                <div>
                  {{ metrics == null ? 0 : metrics.CriticalTicketsCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Oldest Open Ticket:
                </div>
                <div class="float-content-end bg-dark-hover round-15 pl-1" role="button" (click)="doShowOldestTicket()">
                  {{ metrics == null ? "" : metrics.OldestTicketDate | date: 'short' }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10"
                   [class.bg-lightblue]="showTicketsWithNoResponse">
                <div role="button" class="round-10 bg-dark-hover pl-1 pr-1" (click)="doShowTicketsWithNoResponse()">
                  Tickets With No Response
                </div>
                <div>
                  {{ metrics == null ? 0 : metrics.TicketsWithNoResponseCount }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pt-2 pb-2 pl-0 pr-0 mt-2">
            <div class="row justify-content-between">
              <div class="col-12 col-md-6 col-lg-4 p-1 m-0">
                <div class="small-metric-box bg-lightgreen">
                  <div class="more-info-btn" (click)="toggleShowACPInfo(null)" (mouseenter)="toggleShowACPInfo(true)" (mouseleave)="toggleShowACPInfo(false)">
                    <i class="m-0 p-0 fa fa-question" *ngIf="!showACPInfo"></i>
                    <i class="m-0 p-0 fa fa-angle-double-left" *ngIf="showACPInfo"></i>
                  </div>
                  <div class="w-100 p-0 m-0 text-center">
                    <span class="m-0 p-0 font-18 font-bold dark-blue-border-bottom">ACP</span>
                  </div>
                  <div class="row w-100 mt-2">
                    <div class="col-12 m-0 p-0 float-content-center" *ngIf="!showACPInfo">
                      <span class="m-0 p-0 font-20">{{ metrics == null ? '0%' : formatPercentage(metrics.TotalPercentOfAnnualTicketsClosed) }}</span>
                    </div>
                    <div class="col-12 m-0 p-0 text-center" *ngIf="showACPInfo">
                      <span class="m-0 p-1 font-18">Annual Percentage of Total Tickets Closed</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 p-1 m-0">
                <div class="small-metric-box bg-blue-38">
                  <div class="more-info-btn" (click)="toggleShowDRTInfo(null)" (mouseenter)="toggleShowDRTInfo(true)" (mouseleave)="toggleShowDRTInfo(false)">
                    <i class="m-0 p-0 fa fa-question" *ngIf="!showDRTInfo"></i>
                    <i class="m-0 p-0 fa fa-angle-double-left" *ngIf="showDRTInfo"></i>
                  </div>
                  <div class="w-100 p-0 m-0 text-center">
                    <span class="m-0 p-0 font-18 font-bold dark-blue-border-bottom">DRT</span>
                  </div>
                  <div class="row w-100 mt-2">
                    <div class="col-12 m-0 p-0 float-content-center" *ngIf="!showDRTInfo">
                      <span class="m-0 p-0 font-20">{{ metrics == null ? '00:00' : formatHoursMinutes(metrics.AverageDailyResponseTime) }}</span>
                    </div>
                    <div class="col-12 m-0 p-0 text-center" *ngIf="showDRTInfo">
                      <span class="m-0 p-1 font-18">Average Daily Response Time</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 p-1 m-0">
                <div class="small-metric-box bg-lightpurple">
                  <div class="more-info-btn" (click)="toggleShowACRInfo(null)" (mouseenter)="toggleShowACRInfo(true)" (mouseleave)="toggleShowACRInfo(false)">
                    <i class="m-0 p-0 fa fa-question" *ngIf="!showACRInfo"></i>
                    <i class="m-0 p-0 fa fa-angle-double-left" *ngIf="showACRInfo"></i>
                  </div>
                  <div class="w-100 p-0 m-0 text-center">
                    <span class="m-0 p-0 font-18 font-bold dark-blue-border-bottom">ACR</span>
                  </div>
                  <div class="row w-100 mt-2">
                    <div class="col-12 m-0 p-0 float-content-center" *ngIf="!showACRInfo">
                      <span class="m-0 p-0 font-20">{{ metrics == null ? '00:00:00' : formatDaysHoursMinutes(metrics.AverageAnnualCriticalResolutionTime) }}</span>
                    </div>
                    <div class="col-12 m-0 p-0 text-center" *ngIf="showACRInfo">
                      <span class="m-0 p-1 font-18">Annual Critical Ticket Resolution Time</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pt-2 pb-2 pl-0 pr-0">
            <div class="row ml-0 pl-0">
              <div class="col-12 float-content-between">
                <div class="pr-2">
                  <h5 class="content-heading-font pl-0 ml-0">Ticket Search:</h5>
                </div>
                <div class="pl-1 pr-1 hover-color round-corners mb-1" (click)="toggleFilter()">
                  <i class="fa fa-angle-double-up font-18 font-bold" *ngIf="showFilter"></i>
                  <i class="fa fa-angle-double-down font-18 font-bold" *ngIf="!showFilter"></i>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="showFilter">
              <div class="col-12">
                <label for="ticket-submittedby-filter" class="font-14">Submitted By...</label>
                <input type="text" class="form-control" [(ngModel)]="submittedBy" (ngModelChange)="filterSubmittedBy()" />
              </div>
              <div class="col-12">
                <label for="ticket-ticketName-filter" class="font-14">Ticket Name</label>
                <input type="text" class="form-control" [(ngModel)]="ticketName" (ngModelChange)="filterTicketName()" />
              </div>
              <div class="col-6">
                <label for="ticket-ticketID-filter" class="font-14">Ticket ID</label>
                <input type="number" class="form-control" [(ngModel)]="ticketID" (ngModelChange)="loadTickets()" />
              </div>
              <div class="col-6">
                <label for="ticket-priorityID-filter" class="font-14">Priority</label>
                <p-dropdown [options]="availablePriorities()" class="form-control"
                            [(ngModel)]="priorityID" (ngModelChange)="loadTickets()" placeholder="Any" optionLabel="Label" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-6">
                <label for="ticket-typeID-filter" class="font-14">Type</label>
                <p-dropdown [options]="availableTypes()" class="form-control"
                            [(ngModel)]="typeID" placeholder="Any" (ngModelChange)="loadTickets()" optionLabel="Label" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-6">
                <label for="ticket-clientID-filter" class="font-14">Clients</label>
                <p-dropdown [options]="availableClients()" class="form-control"
                            [(ngModel)]="clientID" placeholder="Any" (ngModelChange)="loadTickets()" optionLabel="Label" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-6 mt-2">
                <label for="ticket-createdDateFrom-filter" class="font-14">Created Date From</label>
                <input type="date" class="form-control" [(ngModel)]="createdDateFrom" (ngModelChange)="loadTickets()" />
              </div>
              <div class="col-6 mt-2">
                <label for="ticket-createdDateTo-filter" class="font-14">Created Date To</label>
                <input type="date" class="form-control" [(ngModel)]="createdDateTo" (ngModelChange)="loadTickets()" />
              </div>
              <div class="col-4 mt-2">
                <p-checkbox type="checkbox"
                            class=""
                            name="closed"
                            [binary]="true"
                            [(ngModel)]="closed" (ngModelChange)="loadTickets()" id="ticket-closed-filter"></p-checkbox>
                <label for="ticket-closed-filter" class="ml-1 font-14">Closed</label>
              </div>
              <div class="col-4 mt-2">
                <p-checkbox type="checkbox"
                            class=""
                            name="opened"
                            [binary]="true"
                            [(ngModel)]="opened" (ngModelChange)="loadTickets()" id="ticket-open-filter"></p-checkbox>
                <label for="ticket-open-filter" class="ml-1 font-14">Open</label>
              </div>
              <div class="col-4 mt-2">
                <p-checkbox type="checkbox"
                            class=""
                            name="updated"
                            [binary]="true"
                            [(ngModel)]="updated" (ngModelChange)="loadTickets()" id="ticket-updated-filter"></p-checkbox>
                <label for="ticket-updated-filter" class="ml-1 font-14">Updated</label>
              </div>
              <div class="col-6 mt-2">
                <p-checkbox type="checkbox"
                            class=""
                            name="waitingForResponse"
                            [binary]="true"
                            [(ngModel)]="waitingForResponse" (ngModelChange)="loadTickets()" id="ticket-waitingForResponse-filter"></p-checkbox>
                <label for="ticket-waitingForResponse-filter" class="ml-1 font-14">Waiting For Repsonse</label>
              </div>
              <div class="col-6 mt-2">
                <p-checkbox type="checkbox"
                            class=""
                            name="showOnlyTicketsMissingGithubIssue"
                            [binary]="true"
                            [(ngModel)]="showOnlyTicketsMissingGithubIssue" (ngModelChange)="loadTickets()" id="ticket-waitingForResponse-filter"></p-checkbox>
                <label for="ticket-showOnlyTicketsMissingGithubIssue-filter" class="ml-1 font-14">Missing Github Issue</label>
              </div>
            </div>
          </div>
          <div class="col-12 pt-2 pb-2 mt-2 left-ticket-container bg-white">
            <div class="row">
              <div class="col-12 left-menu-ticket p-2 mt-1 mb-1" (click)="openTicket(ticket.ID)" *ngFor="let ticket of all">
                <div class="row justify-content-center font-bold">
                  <div class="col-8 p-0 m-0 float-content-start font-16">
                    <p class="ml-1 mb-0">{{ ticket.Client_Name}}</p>
                  </div>
                  <div class="col-4 m-0 p-0 float-content-end font-16">
                    <p class="mr-1 mb-0">{{ ticket.Client }}</p>
                  </div>
                  <div class="col-12 p-0 m-0 float-content-end font-14">
                    <p class="mr-1">{{ ticket.DateCreated | date:'short' }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 float-content-center">
                    <p class="pl-0 ml-0">{{ ticket.Subject }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-9">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="row ticket-category-container mb-3 p-2">
              <div class="col-12 display-flex text-center justify-content-between align-items-center">
                <h5 class="content-heading-font">Unread</h5>
                <h4 class="content-heading-font bg-blue-38 round-15 pl-2 pr-2 pb-1">{{ unreadCount }}</h4>
              </div>
              <div class="col-12 m-0 p-0 fit-height ticket-category-body">
                <div class="row mb-2 fit-height" *ngFor="let ticket of unread">
                  <app-ticket-list-item [ticket]=ticket
                                        (updatePinnedTickets)="updatePinnedTickets($event)"
                                        (reloadTickets)="loadTickets()"></app-ticket-list-item>
                </div>
              </div>
            </div>
            <div class="row ticket-category-container p-2">
              <div class="col-12 display-flex text-center justify-content-between align-items-center">
                <h5 class="content-heading-font">Bugs</h5>
                <h4 class="content-heading-font bg-blue-38 round-15 pl-2 pr-2 pb-1">{{ bugCount }}</h4>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="row m-0 p-0 ticket-category-body">
                  <div class="col-12 mb-2" *ngFor="let ticket of bugs">
                    <app-ticket-list-item [ticket]=ticket
                                          (updatePinnedTickets)="updatePinnedTickets($event)"
                                          (reloadTickets)="loadTickets()"></app-ticket-list-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="row ticket-category-container mb-3 mt-size-dependant p-2">
              <div class="col-12 display-flex text-center justify-content-between align-items-center">
                <h5 class="content-heading-font">Critical</h5>
                <h4 class="content-heading-font bg-blue-38 round-15 pl-2 pr-2 pb-1">{{ criticalCount }}</h4>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="row m-0 p-0 ticket-category-body">
                  <div class="col-12 mb-2" *ngFor="let ticket of critical">
                    <app-ticket-list-item [ticket]=ticket
                                          (updatePinnedTickets)="updatePinnedTickets($event)"
                                          (reloadTickets)="loadTickets()"></app-ticket-list-item>
                  </div>
                </div>
              </div>
            </div>
            <div class="row ticket-category-container p-2">
              <div class="col-12 display-flex text-center justify-content-between align-items-center">
                <h5 class="content-heading-font">Feature Requests</h5>
                <h4 class="content-heading-font bg-blue-38 round-15 pl-2 pr-2 pb-1">{{ featureRequestsCount }}</h4>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="row m-0 p-0 ticket-category-body">
                  <div class="col-12 mb-2" *ngFor="let ticket of featureRequests">
                    <app-ticket-list-item [ticket]=ticket
                                          (updatePinnedTickets)="updatePinnedTickets($event)"
                                          (reloadTickets)="loadTickets()"></app-ticket-list-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="row ticket-category-container mb-3 p-2">
              <div class="col-12 display-flex text-center justify-content-between align-items-center">
                <h5 class="content-heading-font">Other</h5>
                <h4 class="content-heading-font bg-blue-38 round-15 pl-2 pr-2 pb-1">{{ miscCount }}</h4>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="row m-0 p-0 ticket-category-body">
                  <div class="col-12 mb-2" *ngFor="let ticket of misc">
                    <app-ticket-list-item [ticket]=ticket
                                          (updatePinnedTickets)="updatePinnedTickets($event)"
                                          (reloadTickets)="loadTickets()"></app-ticket-list-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
    <div class="row">
      <div class="col mb-3">
        <label for="gitHubIssue">Issue</label><br />
        <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
          <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
            {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3">
        <label for="gitHubComment">Comment</label><br />
        <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
        <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
      </div>
    </div>
  </p-dialog>
